import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import PartsImportsTrackingDashboard from './dashboard/index';

export const partsImportsRoutes = [
  {
    'component': <PartsImportsTrackingDashboard />,
    'path': paths.PartsImportsTrackingDashboard,
  },
];
